import {ApiResponse} from "@/services/responses/ApiResponse";
import {EventBus} from "@/pitprojekt/event-bus";
import NProgress from "nprogress";

export class AuthenticationError extends ApiResponse {

    constructor(message: string, status: number = 401, autoSnackbar: boolean = true) {
        super(message, status);
        if (autoSnackbar && message) this.showSnackbar();
        NProgress.done();
    }

    showSnackbar() {
        if (this.message) EventBus.$emit('showSnackbarEvent', this.message, 'error');
    }

}
